import eventBus from '@sd-utility/eventbus';
import { PLPQueryData, usePLPQuery } from 'client/api/plp-results';
import { PLP_UPDATE_EVENT } from 'client/config';
import { useCallback, useEffect, useRef } from 'react';

const useUpdateEvent = (disableInitial?: boolean) => {
  const { data: resultId } = usePLPQuery(useCallback((d: PLPQueryData) => d.meta.result_id, []));

  // if disable initial is true, then we only fire the event when the deps change after initial render
  // this is to prevent firing the event on mount for product cards so that it is only
  // triggered when the product is saved/unsaved
  const initRender = useRef(disableInitial);

  useEffect(() => {
    if (initRender.current) {
      initRender.current = false;
      return;
    }
    setTimeout(() => eventBus.publish(PLP_UPDATE_EVENT));
  }, [resultId]);
};

export default useUpdateEvent;
